import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ReferralModel from "../../models/referral";

export default class ReferralRepository extends BaseRepository {
  static modelClass = ReferralModel;
  modelName = "referral";

  async createBulk(data) {
    return await super.createBulk(data, {
      urlPath: "referrals/bulk_create",
    });
  }

  async updateBulk(data) {
    return await super.createBulk(data, {
      urlPath: "referrals/bulk_update",
    });
  }

  async deleteBulk(data) {
    return await super.createBulk(data, {
      urlPath: "referrals/bulk_delete",
    });
  }
}
